import {useEffect} from "react"
import {useNavigate, useParams} from "react-router-dom"
import {useTranslation} from "react-i18next"

import {PaymentOption} from "./PaymentOption"

import {useAnalytics} from "@indebted/analytics"

function PartialPaymentOptionLink() {
	const {secureCode} = useParams()
	const {track} = useAnalytics()
	const navigate = useNavigate()

	const {t} = useTranslation()

	useEffect(() => {
		track("PartialPaymentOptionOffered", {SecureCode: secureCode})
	}, [secureCode, track])

	return (
		<PaymentOption
			Type="PartialPayment"
			onClick={() => {
				track("PartialPaymentButtonClicked", {SecureCode: secureCode})
				navigate(`/${secureCode}/partial-payment`)
			}}
			Title={t("customer_get.outstanding_balance.partialpayment.partial_payments")}
			Description={t("customer_get.outstanding_balance.partialpayment.make_one_off_payment")}
		/>
	)
}

export {PartialPaymentOptionLink}
